var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-autocomplete', _vm._b({
    attrs: {
      "items": _vm.subjects,
      "item-text": _vm.itemText,
      "item-value": "_id"
    },
    model: {
      value: _vm.$data._subject,
      callback: function callback($$v) {
        _vm.$set(_vm.$data, "_subject", $$v);
      },
      expression: "$data._subject"
    }
  }, 'v-autocomplete', _vm.$attrs, false));
}
var staticRenderFns = []

export { render, staticRenderFns }